import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Workspace from '../workspace/class';
import Logo from '../common/Logo';

const LoginWrapper = ({ workspace, children }) => (
  <React.Fragment>
    <div
      className="content c-login"
      style={{ backgroundImage: `url(${workspace.coverUrl})` }}
    >
      <div className="c-login__overlay">
        <div className="o-wrapper" style={{ flex: 1 }}>
          <div className="o-layout o-layout--stretch">
            <div
              className="o-layout__item u-1/1 u-1/2@super-kalo"
              style={{ flexDirection: 'column', alignItems: 'center' }}
            >
              <Logo className="u-margin-top-large u-margin-bottom-large" />

              <h1>{workspace.welcomeMessage}</h1>
              <p>{workspace.slogan}</p>

              <img
                src={workspace.avatarUrl}
                alt="Workspace Logo"
                width="133"
                className="u-margin-top-large u-margin-bottom-large"
              />
            </div>
            <div
              className="o-layout__item u-1/1 u-1/2@super-kalo"
              style={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

LoginWrapper.propTypes = {
  workspace: PropTypes.instanceOf(Workspace),
};

const mapStateToProps = ({ workspace }) => ({
  workspace: workspace.data,
});

export default connect(mapStateToProps)(LoginWrapper);



// WEBPACK FOOTER //
// ./src/auth/LoginWrapper.js